export default "__VITE_ASSET__DEjAJnrE__"